export const getInitials = (name) => {
  if (!name) return null;

  const nameParts = name.trim()?.split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  }
};


export const tableScrollTop = (delay = 100) => {
  setTimeout(() => {
    const tableBody = document.querySelector(".ant-table-body");
    if (tableBody) {
      tableBody.scrollTop = 0;
    }
  }, delay);
};
